const FBconfig = {
    apiKey: "AIzaSyAaGb2F1BoVYeu-7Yjjij47tg4dekN7ZuQ",
    authDomain: "motivate-dashboarding.firebaseapp.com",
    databaseURL: "https://motivate-dashboarding.firebaseio.com",
    projectId: "motivate-dashboarding",
    storageBucket: "motivate-dashboarding.appspot.com",
    messagingSenderId: "41301205550"
};

export default FBconfig